var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartBlackAndWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0507 3.82312C19.494 3.8231 17.5445 6.03121 15.9981 7.56249C14.4517 6.03121 12.5022 3.8231 8.94556 3.82312C5.38894 3.82314 1.71011 7.17895 1.89329 11.973C1.89329 18.7806 11.1157 24.7731 15.9981 28.1769C20.8805 24.7731 30.1029 18.7806 30.1029 11.973C30.2861 7.17895 26.6073 3.82314 23.0507 3.82312Z",
    fill: "url(#paint0_radial_32112_21108)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_32112_21108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4224 3.82312) rotate(127.736) scale(30.795 36.9338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330493,
    stopColor: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330593,
    stopColor: "#91919C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630108,
    stopColor: "#91919C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#696970"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBlackAndWhite);
export default __webpack_public_path__ + "static/media/HeartBlackAndWhite.5e86f2841017267140f741b150330f22.svg";
export { ForwardRef as ReactComponent };